import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export const UserSearchFields = ({ searchFields, selectSearchField, error }) => {
    const [field, setSearchField] = React.useState('');

    const handleChange = (event) => {
        setSearchField(event.target.value);
        selectSearchField(event.target.value);
    };

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Search Field</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={field}
                    label="Search Field"
                    onChange={handleChange}
                    error={error}
                >
                    {
                        searchFields.map((interval, i) =>
                            <MenuItem key={i} value={interval}>
                                {interval}
                        </MenuItem>
                        )
                    }
                </Select>
            </FormControl>
        </Box>
    );
}
